import { params } from "../../vars/params";
import { config } from "../../../config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export const topMv = () => {
  const isHome = document.body.classList.contains("home");
  const mvSlider = document.querySelector(".p-top-mv-slider");
  const mvTxt = document.querySelector(".p-top-mv__txt");
  const mvNav = document.querySelector(".p-top-mv-nav");
  const mvNews = document.querySelector(".p-top-mv__news");
  const header = document.querySelector(".l-header");

  const tl = gsap.timeline();
  if (isHome) {
    // const splitText = new SplitText(mvTxt, { types: "chars", tag: "span" });

    tl.to(mvSlider, {
      opacity: 1,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power2.out",
    });

    tl.to(
      header,
      {
        opacity: 1,
        duration: 1.2,
        ease: "power2.out",
      },
      0.3
    );

    // tl.to(
    //   splitText.chars,
    //   {
    //     opacity: 1,
    //     y: 0,
    //     filter: "blur(0px)",
    //     duration: 1.2,
    //     ease: "power2.out",
    //     stagger: 0.1,
    //   },
    //   0.6
    // );

    tl.to(
      mvNav,
      {
        opacity: 1,
        filter: "blur(0px)",
        duration: 1.2,
        ease: "power2.out",
      },
      1.8
    );

    if (mvNews) {
      tl.to(
        mvNews,
        {
          opacity: 1,
          filter: "blur(0px)",
          duration: 1.2,
          ease: "power2.out",
        },
        2
      );
    }
  }
};
